import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReadListTableComponent } from './read-list-table.component';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { HighlightPipeModule } from '@schoolbelle/shared/pipes';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';


@NgModule({
  imports: [
    CommonModule,
    VirtualScrollerModule,
    HighlightPipeModule, PopoverModule.forRoot(), TooltipModule.forRoot(),

  ],
  declarations: [ReadListTableComponent],
  exports:[ReadListTableComponent],
})
export class ReadListTableModule { }
